import React, { useState } from "react";
import { Badge } from "@/components/ui/Badge";
import { ButtonShadcn } from "@/components/ui/Button";
import { Card, CardContent } from "@/components/ui/Card";
import { toLanguageStrings } from "@/utils/languageRequirements";

const SKILLS_LIMIT = 15;

const parseLang = (str) => {
  const [name, ...rest] = String(str).split(/\s*—\s*/);
  return { name: name.trim(), proficiency: rest.join(" — ").trim() };
};

export const Skills = ({ data }) => {
  const [skillsExpanded, setSkillsExpanded] = useState(false);
  const [langsExpanded, setLangsExpanded]   = useState(false);

  const skills    = Array.isArray(data?.skills)    ? data.skills    : [];
  // Extraction emits pairs [{ language, proficiency }]; normalizing here
  // keeps the "Language — Level" rendering below working for every shape.
  const languages = toLanguageStrings(data?.languages);

  const isEmpty = !skills.length && !languages.length;

  const visibleSkills = skillsExpanded ? skills : skills.slice(0, SKILLS_LIMIT);
  const visibleLangs  = langsExpanded  ? languages : languages.slice(0, SKILLS_LIMIT);

  if (isEmpty) {
    return <p className="text-sm text-text-muted">No data available</p>;
  }

  return (
    <Card className=" border-none border-border-primary p-0">
      <CardContent className="p-0 flex flex-col gap-4">

        {/* Skills */}
        {skills.length > 0 && (
          <div>
            <p className="text-sm text-text-primary mb-3">Skills</p>
            <div className="flex flex-wrap gap-2">
              {visibleSkills.map((skill, i) => (
                <Badge
                  key={`skill-${i}`}
                  label={skill}
                  variant="gradient"
                  colorIndex={0}
                  className="!rounded-md !border-[1px] !text-text-primary"
                />
              ))}
              {skills.length > SKILLS_LIMIT && (
                <ButtonShadcn
                  variant="ghost"
                  onClick={() => setSkillsExpanded((v) => !v)}
                  className="h-auto px-3 py-1 text-sm font-semibold rounded-md text-button-secondary border border-border-primary transition"
                >
                  {skillsExpanded ? "Show less" : `+${skills.length - SKILLS_LIMIT} more`}
                </ButtonShadcn>
              )}
            </div>
          </div>
        )}

        {/* Languages */}
{/* Languages */}
{languages.length > 0 && (
  <div>
    <p className="text-sm text-text-primary mb-3">Languages</p>

    <ul className="space-y-1 pl-5 list-disc">
      {visibleLangs.map((lang, i) => {
        const { name, proficiency } = parseLang(lang);

        return (
          <li
            key={`lang-${i}`}
            className="text-sm text-text-primary"
          >
            {name}
            {proficiency && (
              <span className="text-text-muted">
                {" "}
                — {proficiency}
              </span>
            )}
          </li>
        );
      })}
    </ul>

    {languages.length > SKILLS_LIMIT && (
      <ButtonShadcn
        variant="ghost"
        onClick={() => setLangsExpanded((v) => !v)}
        className="h-auto mt-3 px-3 py-1 text-xs border border-button-secondary bg-background-primary rounded-md text-text-secondary hover:text-text-primary hover:bg-background-tertiary/20 transition"
      >
        {langsExpanded
          ? "Show less"
          : `+${languages.length - SKILLS_LIMIT} more`}
      </ButtonShadcn>
    )}
  </div>
)}

      </CardContent>
    </Card>
  );
};

export default Skills;